module.exports = __webpack_public_path__ + "static/media/playspace_section4.9e0d936c.png";